import script from "./scrapped.vue?vue&type=script&setup=true&lang=ts"
export * from "./scrapped.vue?vue&type=script&setup=true&lang=ts"

import "./scrapped.vue?vue&type=style&index=0&id=77164a6d&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77164a6d"]])

export default __exports__